// extracted by mini-css-extract-plugin
export default {"-large":"rR9sQwub1PIC92PAs6OL","mediaItem":"yCVuWUwRnhfWgdJGDVSe"};